import IconButton from '@mui/material/IconButton';

import styled from 'styled-components';

import { MenuItem as MuiMenuItem } from '@mui/material';

export const MenuItem = styled(MuiMenuItem)`
  font-size: 14px;
`;

// Every row reserves the grip gutter, so nothing shifts on hover and rows that
// can't be dragged still line up with the ones that can.
export const HANDLE_SLOT_WIDTH = 20;

export const FolderItem = styled.div<{ $selected: boolean; $depth: number; $blockedTarget?: boolean }>`
  display: flex;
  align-items: center;
  padding: 0px 8px;
  padding-left: ${({ $depth }) => 8 + $depth * 16}px;
  margin: 0;
  border-radius: 5px;
  cursor: pointer;
  background: ${({ $selected, theme }) => ($selected ? theme.palette.info.dark : 'transparent')};
  transition: background 0.15s ease;
  height: 36px;

  &:hover {
    background: ${({ $selected, theme }) => ($selected ? theme.palette.info.dark : theme.palette.primary.dark)};

    .menu-button,
    .drag-handle {
      opacity: 1;
    }
  }

  ${({ $blockedTarget }) =>
    $blockedTarget &&
    `
    opacity: 0.35;
    pointer-events: none;
  `}
`;

export const DragHandle = styled.div<{ $enabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${HANDLE_SLOT_WIDTH}px;
  flex: 0 0 ${HANDLE_SLOT_WIDTH}px;
  opacity: 0;
  color: ${({ theme }) => theme.palette.common.white};
  cursor: ${({ $enabled }) => ($enabled ? 'grab' : 'default')};
  transition: opacity 0.15s ease;

  &:active {
    cursor: ${({ $enabled }) => ($enabled ? 'grabbing' : 'default')};
  }

  &:focus-visible {
    opacity: 1;
    outline: 1px solid ${({ theme }) => theme.palette.common.white};
    outline-offset: -1px;
  }

  svg {
    font-size: 18px;
  }
`;

export const ExpandIcon = styled.div<{ $visible: boolean; $expanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 4px;
  color: ${({ theme }) => theme.palette.common.white};
`;

export const FolderName = styled.span<{ $selected: boolean }>`
  font-size: 14px;
  color: ${({ $selected, theme }) => ($selected ? theme.palette.common.white : theme.palette.common.white)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const MenuButton = styled(IconButton)`
  opacity: 0;
  padding: 4px;
  margin-left: auto;
  margin-top: 4px;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.palette.common.white};
  transition: opacity 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.palette.grey[900]};
  }
`;

export const DocumentName = styled.span<{ $selected: boolean }>`
  font-size: 14px;
  color: ${({ $selected, theme }) => ($selected ? theme.palette.common.white : theme.palette.common.white)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;

export const EmptyFolderText = styled.span`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  font-style: italic;
  padding: 4px 8px;
  display: block;
`;

export const ModalBoundary = styled.div`
  display: contents;
`;
